import React from "react";
import Records from "./Records.json";
import "../Styling/Layout.css";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardActions,
  CardMedia,
  Button,
  Box,
} from "@mui/material";

const Courses = () => {
  return (
    <Box
      container
      spacing={3}
      sx={{
        flexWrap: "wrap",
        display: "flex",
      }}
    >
      {Records.map((record) => {
        return (
          <>
            <Grid key={record.id}>
              <a href={record.links}>
                <Card
                  sx={{
                    width: 283,
                    height: 360,
                    marginLeft: "75px",
                    marginBottom: "80px",
                  }}
                >
                  <CardMedia
                    sx={{ height: 200 }}
                    image={record.img}
                    title={record.title}
                  />
                  <CardContent sx={{ height: 70 }}>
                    <Typography gutterBottom variant="h7" component="div">
                      <b>{record.title}</b>
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {record.description}
                    </Typography>
                  </CardContent>
                  <CardActions sx>
                    <Button size="small">Learn More</Button>
                    <Button size="small">Share</Button>
                  </CardActions>
                </Card>
              </a>
            </Grid>
          </>
        );
      })}
    </Box>
  );
};

export default Courses;
